"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireAnswerOption = void 0;
/**
 * A structured set of questions intended to guide the collection of answers from end-users. Questionnaires provide detailed control over order, presentation, phraseology and grouping to allow coherent, consistent data collection.
 */
var QuestionnaireAnswerOption = /** @class */ (function () {
    function QuestionnaireAnswerOption() {
    }
    return QuestionnaireAnswerOption;
}());
exports.QuestionnaireAnswerOption = QuestionnaireAnswerOption;
